export enum ConnectionType {
  BLUETOOTH = 'BLUETOOTH',
  CELLULAR = 'CELLULAR',
  ETHERNET = 'ETHERNET',
  MIXED = 'MIXED',
  NONE = 'NONE',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
  WIFI = 'WIFI',
  WIMAX = 'WIMAX'
}

export enum EffectiveConnectionType {
  TWOG = '2G',
  THREEG = '3G',
  FOURG = '4G',
  SLOW2G = 'SLOW-2G'
}
